import type { EstabelecimentosAplicativoModel, EstabelecimentoItem, EstabelecimentoOption } from "../models/estabelecimentosAplicativoModel"

export enum EstabelecimentosAplicativoActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR_ESTAB = "ADICIONAR_ESTAB",
    REMOVER_ESTAB = "REMOVER_ESTAB",
    SELECIONAR_NOVO = "SELECIONAR_NOVO",
}

export type EstabelecimentosAplicativoActionModel =
    | {
          type: EstabelecimentosAplicativoActionsTypes.CARREGAR
          payload: {
              estabelecimentosDoApp: EstabelecimentoItem[]
              todosEstabelecimentos: EstabelecimentoOption[]
              podeEditar: boolean
          }
      }
    | {
          type: EstabelecimentosAplicativoActionsTypes.ADICIONAR_ESTAB
          payload: EstabelecimentoItem
      }
    | {
          type: EstabelecimentosAplicativoActionsTypes.REMOVER_ESTAB
          payload: number
      }
    | {
          type: EstabelecimentosAplicativoActionsTypes.SELECIONAR_NOVO
          payload: number | null
      }

export type { EstabelecimentosAplicativoModel }
